import { SVGProps } from 'react'

const Bike = (props: SVGProps<SVGSVGElement>) => (
    <svg
        height={64}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 64 64"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                d="M58 0H6a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6Z"
                fill="#fff"
            />
            <path
                d="M37.195 22.244a3.131 3.131 0 0 0 3.122-3.122A3.131 3.131 0 0 0 37.195 16a3.131 3.131 0 0 0-3.122 3.122 3.131 3.131 0 0 0 3.122 3.122ZM20.805 32.39c-4.37 0-7.805 3.434-7.805 7.805C13 44.565 16.434 48 20.805 48c4.37 0 7.805-3.434 7.805-7.805 0-4.37-3.434-7.805-7.805-7.805Zm0 13.268c-2.966 0-5.463-2.497-5.463-5.463s2.497-5.463 5.463-5.463 5.463 2.497 5.463 5.463-2.497 5.463-5.463 5.463Zm9.053-15.61 3.747-3.746 1.249 1.25c2.029 2.029 4.683 3.277 7.96 3.277v-3.122c-2.34 0-4.214-.936-5.619-2.341L34.23 22.4c-.78-.624-1.56-.937-2.497-.937-.937 0-1.717.313-2.186.937l-4.37 4.37c-.625.625-.937 1.406-.937 2.186 0 .937.312 1.717.937 2.186l4.995 4.37v7.805h3.122V33.64l-3.434-3.59Zm12.8 2.342c-4.37 0-7.804 3.434-7.804 7.805 0 4.37 3.434 7.805 7.804 7.805 4.371 0 7.805-3.434 7.805-7.805 0-4.37-3.434-7.805-7.805-7.805Zm0 13.268c-2.965 0-5.463-2.497-5.463-5.463s2.498-5.463 5.463-5.463c2.966 0 5.464 2.497 5.464 5.463s-2.498 5.463-5.464 5.463Z"
                fill="#FF0101"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h64v64H0z" />
            </clipPath>
        </defs>
    </svg>
)

export default Bike
